import React from "react";
import Container from "react-bootstrap/Container";
import {
  AccountContext,
  RetryBehavior,
} from "../common/context/AccountContext";

export const FetchedHtmlPage: React.FC<{ apiQueryPath: string }> = ({
  apiQueryPath,
}: {
  apiQueryPath: string;
}) => {
  const { makeRequest } = React.useContext(AccountContext);
  const [htmlContent, setHtmlContent] = React.useState("");

  React.useEffect(() => {
    makeRequest(apiQueryPath, "GET", RetryBehavior.RETRY_ALL, false)
      .then((resp) => resp.text())
      .then((text) => setHtmlContent(text));
  }, [apiQueryPath, setHtmlContent, makeRequest]);

  return (
    <Container>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Container>
  );
};
